var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 271.446,
    height: 173.671,
    viewBox: "0 0 271.446 173.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "No data-pana"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2064",
    transform: "rotate(-33.78 108.229 15.533)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h60.913v89.693H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1597",
    d: "m241.113 275.248-.573 3.556-25.17-3.628.573-3.556z",
    transform: "translate(-157.142 -175.293)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1598",
    d: "m239.457 251.55 3.61.519-4 24.782-3.614-.523z",
    transform: "translate(-168.161 -164.279)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1599",
    d: "M165.282 181.749c.036.05-5.036 3.511-11.331 7.716s-11.425 7.581-11.462 7.527 5.036-3.511 11.331-7.721 11.403-7.571 11.462-7.522z",
    transform: "translate(-117.148 -125.975)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1600",
    d: "M188.223 171.39c.036.054-8.4 5.758-18.844 12.743s-18.952 12.6-18.979 12.553 8.393-5.762 18.848-12.748 18.939-12.603 18.975-12.548z",
    transform: "translate(-121.489 -120.29)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1601",
    d: "M196.493 183.75c.036.054-8.4 5.762-18.844 12.748S158.7 209.1 158.67 209.046s8.4-5.758 18.848-12.748 18.939-12.598 18.975-12.548z",
    transform: "translate(-126.028 -127.073)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1602",
    d: "M204.8 196.119c.036.054-8.4 5.762-18.844 12.743S167 221.47 167 221.416s8.4-5.762 18.844-12.748 18.916-12.603 18.956-12.549z",
    transform: "translate(-130.599 -133.861)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1603",
    d: "M213.008 208.49c.036.054-8.4 5.758-18.844 12.743s-18.952 12.6-18.975 12.549 8.411-5.758 18.866-12.743 18.953-12.604 18.953-12.549z",
    transform: "translate(-135.093 -140.649)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2065",
    transform: "rotate(-33.78 270.26 -254.347)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h51.157v75.326H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1604",
    d: "m612.9 361.476-.483 2.987-21.141-3.046.487-2.987z",
    transform: "translate(-363.426 -222.931)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1605",
    d: "m611.516 341.57 3.032.438-3.362 20.811-3.037-.438z",
    transform: "translate(-372.684 -213.679)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1606",
    d: "M549.176 283c.036.054-4.219 2.965-9.508 6.5s-9.6 6.358-9.638 6.317 4.224-2.96 9.508-6.5 9.602-6.396 9.638-6.317z",
    transform: "translate(-329.815 -181.536)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1607",
    d: "M568.51 274.249c.036.054-7.044 4.855-15.793 10.717s-15.911 10.582-15.947 10.527 7.044-4.855 15.793-10.721 15.897-10.572 15.947-10.523z",
    transform: "translate(-333.513 -176.736)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1608",
    d: "M575.46 284.63c.036.054-7.044 4.855-15.793 10.721s-15.911 10.577-15.947 10.523 7.021-4.833 15.793-10.7 15.92-10.594 15.947-10.544z",
    transform: "translate(-337.327 -182.432)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1609",
    d: "M582.4 295c.036.054-7.048 4.855-15.793 10.721S550.7 316.3 550.66 316.244s7.044-4.851 15.794-10.722S582.368 294.954 582.4 295z",
    transform: "translate(-341.136 -188.123)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1610",
    d: "M589.4 305.409c.036.054-7.044 4.851-15.793 10.717S557.7 326.7 557.66 326.654s7.044-4.855 15.793-10.721 15.888-10.578 15.947-10.524z",
    transform: "translate(-344.977 -193.835)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2066",
    transform: "rotate(28.14 44.265 234.646)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h52.615v77.474H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1611",
    d: "m334.755 207.248-2.942 1.006-7.473-20.654 2.947-1.011z",
    transform: "translate(-216.941 -128.632)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1612",
    d: "m332.473 199.53 1.074 2.965-20.513 7.026-1.074-2.965z",
    transform: "translate(-210.147 -135.733)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1613",
    d: "M364.318 118.417c-.036.068-4.738-2.378-10.509-5.46s-10.415-5.64-10.379-5.708 4.743 2.378 10.514 5.46 10.41 5.635 10.374 5.708z",
    transform: "translate(-227.416 -85.092)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1614",
    d: "M372.255 136.686c-.036.068-7.824-4.03-17.4-9.147s-17.3-9.323-17.26-9.39 7.82 4.025 17.391 9.147 17.305 9.322 17.269 9.39z",
    transform: "translate(-224.217 -91.074)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1615",
    d: "M366.2 148.016c-.036.068-7.824-4.025-17.4-9.147s-17.3-9.323-17.26-9.39 7.82 4.03 17.391 9.147 17.3 9.322 17.269 9.39z",
    transform: "translate(-220.891 -97.291)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1616",
    d: "M360.135 159.351c-.036.068-7.824-4.025-17.4-9.142s-17.3-9.309-17.26-9.39 7.82 4.025 17.391 9.142 17.305 9.322 17.269 9.39z",
    transform: "translate(-217.566 -103.514)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1617",
    d: "M354.075 170.681c-.036.068-7.824-4.025-17.4-9.142s-17.3-9.323-17.26-9.39 7.82 4.025 17.391 9.142 17.305 9.323 17.269 9.39z",
    transform: "translate(-214.241 -109.732)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1619",
    d: "M346.849 439.687c0 .063-58.323.117-130.255.117s-130.264-.041-130.264-.117 58.314-.117 130.264-.117 130.255.05 130.255.117z",
    transform: "translate(-86.33 -267.457)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1620",
    d: "M116.248 377.194a5.7 5.7 0 0 1 3.962 2.031 10 10 0 0 1 2.017 4.061 17.748 17.748 0 0 1-.519 9.061c-3.086-1.106-5-4.4-5.866-6.132-1.354-2.734-2.161-8.51.393-9.025",
    transform: "translate(-101.826 -233.226)",
    style: {
      fill: "#014a62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1621",
    d: "M139.3 408.5a4.846 4.846 0 0 1-.226-4.864 6.435 6.435 0 0 1 3.881-3.118 2.7 2.7 0 0 1 2.283.108 2.067 2.067 0 0 1 .8 1.945 4.183 4.183 0 0 1-.9 1.995c-1.5 2.035-3.326 3.727-5.866 3.935",
    transform: "translate(-114.973 -245.919)",
    style: {
      fill: "#014a62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1622",
    d: "M139.93 422.228a2.931 2.931 0 0 1-.14-.591c-.081-.424-.19-.97-.32-1.624a17.044 17.044 0 0 1-.334-5.465 10.379 10.379 0 0 1 2.026-5.058 6.913 6.913 0 0 1 1.169-1.187 4.125 4.125 0 0 1 .37-.262.519.519 0 0 1 .135-.081 11.449 11.449 0 0 0-1.557 1.62 10.762 10.762 0 0 0-1.931 5 18.348 18.348 0 0 0 .275 5.415c.108.69.2 1.25.248 1.638a3.713 3.713 0 0 1 .059.595z",
    transform: "translate(-115.261 -250.111)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1623",
    d: "M120.49 386.83a1.057 1.057 0 0 1 .126.23c.081.181.19.406.316.69.275.6.659 1.471 1.124 2.55.93 2.161 2.175 5.167 3.475 8.515s2.405 6.4 3.159 8.628c.388 1.11.69 2.013.9 2.64.095.3.167.537.226.722a1.178 1.178 0 0 1 .068.257 1.112 1.112 0 0 1-.108-.244c-.068-.18-.153-.415-.266-.708l-.952-2.617c-.808-2.207-1.936-5.257-3.231-8.6s-2.522-6.358-3.416-8.533c-.451-1.069-.8-1.94-1.056-2.577-.117-.289-.212-.519-.284-.7a1.574 1.574 0 0 1-.081-.253z",
    transform: "translate(-105.076 -238.516)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1624",
    d: "M119.046 418.928a11.362 11.362 0 0 0-8.808-5.474c-.9-.063-2.013.09-2.419.9a2.343 2.343 0 0 0 .758 2.464 9.7 9.7 0 0 0 10.5 2.346",
    transform: "translate(-98.045 -253.12)",
    style: {
      fill: "#014a62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1625",
    d: "M116.43 418.885a3.214 3.214 0 0 1 .573.023 5.459 5.459 0 0 1 .663.077c.257.05.56.077.875.167a8.766 8.766 0 0 1 1.042.289 10.355 10.355 0 0 1 1.16.451 12.547 12.547 0 0 1 2.446 1.449 12.324 12.324 0 0 1 2.022 2 10.142 10.142 0 0 1 .708 1.015 9.9 9.9 0 0 1 .532.943 7.861 7.861 0 0 1 .361.812 5.117 5.117 0 0 1 .23.632 3.075 3.075 0 0 1 .149.555c-.05 0-.266-.776-.875-1.931a9.933 9.933 0 0 0-.546-.9 11.421 11.421 0 0 0-.713-.988 12.025 12.025 0 0 0-4.4-3.393c-.393-.171-.767-.334-1.133-.451a9.872 9.872 0 0 0-1.024-.311c-1.258-.349-2.075-.389-2.07-.439z",
    transform: "translate(-102.848 -256.104)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1626",
    d: "M562.139 104.339c-1.327.3-1.972 1.832-2.1 3.186s.045 2.789-.524 4.025c-.641 1.39-2.17 2.419-2.22 3.948-.032.934.523 1.8.5 2.748-.045 1.534-1.606 2.707-1.692 4.224-.059 1.106.677 2.161.5 3.253-.135.848-.8 1.516-1.079 2.328-.555 1.624.56 3.407 2.008 4.318a6.584 6.584 0 0 0 9.589-3.059c.8-1.949.627-4.147.451-6.245q-.812-9.819-1.209-19.665",
    transform: "translate(-343.725 -82.981)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1627",
    d: "M561.82 129.178a1.539 1.539 0 0 0 .609-.717 2.613 2.613 0 0 0 .153-1.106 6.079 6.079 0 0 0-.329-1.457 4.2 4.2 0 0 1-.235-1.85 4.252 4.252 0 0 1 1.074-1.85 3.955 3.955 0 0 0 .609-.925 1.494 1.494 0 0 0 .072-1.083c-.235-.736-.957-1.277-1.286-2.13a2.256 2.256 0 0 1-.072-1.318 5.227 5.227 0 0 1 .451-1.178 10.108 10.108 0 0 0 .9-2.125c.316-1.43.167-2.8.384-3.921a4.34 4.34 0 0 1 1.142-2.4 2.619 2.619 0 0 1 .6-.451.933.933 0 0 1 .239-.086 3.471 3.471 0 0 0-.772.578 4.414 4.414 0 0 0-1.042 2.369 14.706 14.706 0 0 0-.126 1.8 11.121 11.121 0 0 1-.208 2.116 10.139 10.139 0 0 1-.9 2.175 2.979 2.979 0 0 0-.352 2.315c.3.776 1.015 1.313 1.291 2.143a1.75 1.75 0 0 1-.086 1.241 4.267 4.267 0 0 1-.677 1.015 4.281 4.281 0 0 0-1.051 1.742 4.062 4.062 0 0 0 .208 1.773 6.141 6.141 0 0 1 .3 1.5 2.53 2.53 0 0 1-.2 1.146 1.38 1.38 0 0 1-.451.569.714.714 0 0 1-.245.115z",
    transform: "translate(-347.26 -84.726)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1628",
    d: "m524.96 180.37-4.06 11.73-16.985.9-2.834 6.317 17.734 1.8a6.7 6.7 0 0 0 8.853-3.939l4.734-13.212z",
    transform: "translate(-313.928 -125.219)",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1629",
    d: "M593.43 331.061s-12.445-39.538-12.711-40.819c-.239-1.164 4.512-29.615 5.117-37l-16.818.627v.167l-7.148.4 6.4 80.826h7.739l-.767-26.826a261.626 261.626 0 0 0 11.615 25.87z",
    transform: "translate(-347.287 -165.207)",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1630",
    d: "M588.56 376.117c0-.244-.095-8.989-.095-8.989-.095.523-2.965-7.59-2.9-8.082.035-.257 2.995 17.071 2.995 17.071z",
    transform: "translate(-360.291 -223.268)",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1631",
    d: "M584.767 350.53a1.751 1.751 0 0 0-.05.492 12.184 12.184 0 0 0 0 1.354 8.99 8.99 0 0 0 .077.925c.036.334.086.686.162 1.051a18.669 18.669 0 0 0 .636 2.355c.56 1.638 1.182 3.068 1.62 4.106.208.451.388.88.541 1.223a1.953 1.953 0 0 0 .226.451 1.712 1.712 0 0 0-.135-.451c-.1-.3-.262-.726-.451-1.254-.4-1.056-.993-2.5-1.548-4.12a19.564 19.564 0 0 1-.645-2.319c-.081-.361-.135-.708-.185-1.033s-.086-.632-.108-.9a23.71 23.71 0 0 1-.09-1.327 2.038 2.038 0 0 0-.05-.55z",
    transform: "translate(-359.815 -218.596)",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1632",
    d: "M569.257 434.6v-.727l7.928-.347.023 3-.487.032c-2.18.126-11.078.5-12.531.059-1.63-.483 5.067-2.017 5.067-2.017z",
    transform: "translate(-348.42 -264.143)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1633",
    d: "M577.3 439.78a1.022 1.022 0 0 1-.135 0l-.388.027-1.435.063c-1.209.05-2.884.095-4.729.1s-3.524-.023-4.738-.059l-1.43-.059h-.528a.835.835 0 0 1 .135 0h.393l1.435.027c1.209 0 2.883.036 4.729.027s3.524-.041 4.734-.072l1.435-.036h.523z",
    transform: "translate(-348.412 -267.573)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1634",
    d: "M569.073 438.847a3.464 3.464 0 0 0-.271-.681 3.255 3.255 0 0 0-.492-.546 1.046 1.046 0 0 1 .573.5 1.078 1.078 0 0 1 .19.727z",
    transform: "translate(-350.821 -266.387)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1635",
    d: "M574.67 436.913a1.784 1.784 0 0 1-.248-.3c-.117-.18-.189-.338-.167-.352s.131.117.248.3.19.339.167.352z",
    transform: "translate(-354.081 -265.64)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1636",
    d: "M575.994 436.465c0 .023-.144-.063-.28-.185s-.235-.235-.217-.253.144.063.28.185.235.212.217.253z",
    transform: "translate(-354.764 -265.512)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1637",
    d: "M576.486 435.241a.954.954 0 0 1-.415.054.9.9 0 0 1-.411-.041.937.937 0 0 1 .411-.054.9.9 0 0 1 .415.041z",
    transform: "translate(-354.855 -265.055)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1638",
    d: "M576.692 434.14a.839.839 0 0 1-.451.135.851.851 0 0 1-.451-.063 2.6 2.6 0 0 1 .451-.036 2.338 2.338 0 0 1 .451-.036z",
    transform: "translate(-354.926 -264.477)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1639",
    d: "M572.779 435.33a1.382 1.382 0 0 1-.51 0 2.914 2.914 0 0 1-.537-.117 1.457 1.457 0 0 1-.312-.126.284.284 0 0 1-.126-.158.2.2 0 0 1 .077-.2.939.939 0 0 1 1.318.609.342.342 0 0 1 0 .135 1.453 1.453 0 0 0-.235-.451.929.929 0 0 0-.451-.28.8.8 0 0 0-.6.045c-.077.059-.045.153.041.208a1.628 1.628 0 0 0 .289.122 3.784 3.784 0 0 0 .519.131c.333.069.527.069.527.082z",
    transform: "translate(-352.456 -264.748)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1640",
    d: "M574.211 435.044a.478.478 0 0 1-.063-.352.839.839 0 0 1 .14-.37.514.514 0 0 1 .42-.262.208.208 0 0 1 .158.235.536.536 0 0 1-.086.226 1.861 1.861 0 0 1-.239.311.74.74 0 0 1-.289.2 3.183 3.183 0 0 0 .239-.253 1.749 1.749 0 0 0 .212-.3c.068-.108.117-.3 0-.325s-.253.117-.329.217a.825.825 0 0 0-.144.329 1.6 1.6 0 0 0-.018.343z",
    transform: "translate(-354.019 -264.434)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1641",
    d: "M589.809 434.934s-.226 0-.582.023a2.5 2.5 0 0 0-2.062 1.656c-.117.338-.126.569-.144.564s0-.059 0-.158a2.02 2.02 0 0 1 .081-.429 2.468 2.468 0 0 1 .794-1.178 2.432 2.432 0 0 1 1.322-.519 1.889 1.889 0 0 1 .451 0 .57.57 0 0 1 .14.041z",
    transform: "translate(-361.084 -264.884)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1642",
    d: "M582 438.369a4.424 4.424 0 0 1-1.155.113 4.257 4.257 0 0 1-1.151-.1c0-.027.514 0 1.151 0s1.146-.04 1.155-.013z",
    transform: "translate(-357.066 -266.793)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1643",
    d: "M587.945 438.345s-.041.108-.095.226-.081.226-.108.221-.041-.122.023-.262.162-.208.18-.185z",
    transform: "translate(-361.472 -266.783)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1644",
    d: "M589.141 436.733a.5.5 0 0 1-.113.18c-.081.081-.162.135-.185.117s.032-.1.113-.185.163-.134.185-.112z",
    transform: "translate(-362.086 -265.898)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1645",
    d: "M590.8 435.946c0 .027-.108.027-.226.068s-.2.1-.221.086.045-.126.19-.176.267-.006.257.022z",
    transform: "translate(-362.916 -265.444)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1646",
    d: "M592.373 435.619c0 .027-.031.068-.1.09s-.126.027-.135 0 .036-.068.1-.09.126-.019.135 0z",
    transform: "translate(-363.897 -265.28)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1647",
    d: "m611.865 429.224-.3-.663 7.089-3.56 1.25 2.707-.451.23c-1.936 1.006-9.9 4.986-11.407 5.185-1.664.239 3.819-3.899 3.819-3.899z",
    transform: "translate(-372.455 -259.462)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1648",
    d: "m619.948 430.57-.117.072-.347.18-1.282.65a138.69 138.69 0 0 1-8.618 3.917l-1.331.537-.361.14a.515.515 0 0 1-.131.041l.122-.059.356-.158 1.318-.564c1.115-.478 2.649-1.146 4.332-1.913s3.195-1.48 4.287-2l1.291-.618.356-.167z",
    transform: "translate(-372.47 -262.519)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1649",
    d: "M612.06 439.752a3.325 3.325 0 0 0-.528-.514 3.129 3.129 0 0 0-.672-.3 1.268 1.268 0 0 1 1.2.812z",
    transform: "translate(-374.171 -267.112)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1650",
    d: "M616.339 435.7a1.617 1.617 0 0 1-.352-.172c-.181-.117-.311-.23-.3-.253s.171.054.352.171.313.231.3.254z",
    transform: "translate(-376.82 -265.098)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1651",
    d: "M617.341 434.749c0 .023-.153 0-.329-.054s-.307-.122-.3-.149a.673.673 0 0 1 .334.054c.169.041.305.1.295.149z",
    transform: "translate(-377.381 -264.699)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1652",
    d: "M617.339 433.08a1.054 1.054 0 0 1-.356.221.951.951 0 0 1-.393.131 1.064 1.064 0 0 1 .352-.221.983.983 0 0 1 .397-.131z",
    transform: "translate(-377.315 -263.896)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1653",
    d: "M617.057 431.9a1.23 1.23 0 0 1-.366.311.786.786 0 0 1-.451.135 2.376 2.376 0 0 1 .411-.221c.221-.125.383-.251.406-.225z",
    transform: "translate(-377.123 -263.245)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1654",
    d: "M614.128 434.685a1.461 1.461 0 0 1-.451.208 3.546 3.546 0 0 1-.542.113 1.352 1.352 0 0 1-.334 0 .267.267 0 0 1-.181-.09.2.2 0 0 1 0-.217.93.93 0 0 1 1.16-.226.9.9 0 0 1 .289.239c.054.072.077.117.072.122a1.354 1.354 0 0 0-.393-.3.9.9 0 0 0-.51-.077.789.789 0 0 0-.532.289c-.05.086 0 .158.122.171a1.793 1.793 0 0 0 .311 0 3.57 3.57 0 0 0 .532-.095c.258-.073.457-.15.457-.137z",
    transform: "translate(-375.119 -264.599)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1655",
    d: "M615.431 433.906a.5.5 0 0 1-.2-.3.849.849 0 0 1-.027-.393.51.51 0 0 1 .28-.411c.113-.036.375.194.393.28s-.131.041-.14.113a1.57 1.57 0 0 1-.09.375.7.7 0 0 1-.181.307 3.3 3.3 0 0 0 .117-.325 2.324 2.324 0 0 0 .068-.365c0-.126 0-.32-.144-.289s-.185.208-.217.334a.78.78 0 0 0 0 .357 1.965 1.965 0 0 0 .141.317z",
    transform: "translate(-376.549 -263.743)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1656",
    d: "M630.265 426.36a3.2 3.2 0 0 0-.523.262 2.459 2.459 0 0 0-1.2 2.355c.027.361.113.569.095.578a.572.572 0 0 1-.068-.144 2.341 2.341 0 0 1-.095-.424 2.387 2.387 0 0 1 1.232-2.419 2.14 2.14 0 0 1 .4-.171.555.555 0 0 1 .159-.037z",
    transform: "translate(-383.825 -260.208)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1657",
    d: "M623.628 432.9a6.445 6.445 0 0 1-2.1.957c0-.027.474-.208 1.051-.451s1.036-.53 1.049-.506z",
    transform: "translate(-380.026 -263.796)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1658",
    d: "M629.18 431.469c.023 0 0 .113 0 .244v.248a.368.368 0 0 1-.09-.248c0-.15.068-.258.09-.244z",
    transform: "translate(-384.175 -263.011)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1659",
    d: "M629.613 429.469c.023 0 0 .1-.027.212s-.095.19-.117.18 0-.1.027-.212.09-.189.117-.18z",
    transform: "translate(-384.378 -261.914)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1660",
    d: "M630.753 428c0 .027-.09.068-.18.153s-.14.176-.162.167 0-.135.1-.239a.3.3 0 0 1 .242-.081z",
    transform: "translate(-384.895 -261.106)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1661",
    d: "M632.008 427.173a.18.18 0 0 1-.054.122c-.054.05-.1.077-.122.059s0-.072.054-.122.104-.077.122-.059z",
    transform: "translate(-385.676 -260.651)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1662",
    d: "m575.442 185.2-1.318-16.109 6.769.122a27.1 27.1 0 0 0-.686-7.585 8.79 8.79 0 0 0-5.126-6.317v-.045l-.208-.054a19.326 19.326 0 0 0-6.209-1.62l-8.325.095s-6.358-.812-9.864 3.741c-1.354 1.746-5.555 13.7-5.555 13.7l9.995 4.81-.934-6.629s.19 4.806.8 6.317c.338.848 1.354 3.484 1.354 3.484l-.131 7.951z",
    transform: "translate(-337.986 -110.523)",
    style: {
      fill: "#014a62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1663",
    d: "m600.886 178.425-1.236 5.261h11.656l-.767-8.826z",
    transform: "translate(-368.019 -122.195)",
    style: {
      fill: "#014a62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1664",
    d: "M612.639 194.117a9.341 9.341 0 0 0-1.543-.153c-.957-.054-2.256-.1-3.736-.095s-2.784.072-3.741.144a8.844 8.844 0 0 0-1.539.189 9.774 9.774 0 0 0 1.552 0c.952-.032 2.256-.068 3.727-.072s2.775 0 3.732.023a9.766 9.766 0 0 0 1.548-.036z",
    transform: "translate(-369.353 -132.626)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1665",
    d: "M601.205 174.77a7.042 7.042 0 0 0-.036 1.354c0 .826.036 1.963.086 3.222s.108 2.4.162 3.222a6.723 6.723 0 0 0 .144 1.354 7.042 7.042 0 0 0 .036-1.354c0-.826-.036-1.967-.086-3.226s-.108-2.4-.162-3.222a6.635 6.635 0 0 0-.144-1.35z",
    transform: "translate(-368.844 -122.146)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5354",
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1666",
    d: "M221.758 57.181s2.59 19.209 9.873 18.7c0 0 3.281-.036 4.332-2.216v-.854z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5355",
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1667",
    d: "m232.361 53.757-1.394 9.42.9 1.652 1.489-3.231-.632-.018z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1668",
    d: "M566.836 195.338a1.811 1.811 0 0 1-.2-.451c-.113-.293-.262-.722-.451-1.259a38.882 38.882 0 0 1-1.115-4.264 30.246 30.246 0 0 1-.551-4.373c-.027-.564-.036-1.02-.027-1.354a1.8 1.8 0 0 1 .031-.487c.036 0 .063.695.158 1.8a40.113 40.113 0 0 0 .618 4.336 54.574 54.574 0 0 0 1.042 4.26c.144.5.266.93.366 1.282a2.206 2.206 0 0 1 .126.505z",
    transform: "translate(-348.725 -126.745)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1669",
    d: "M575.5 220.085a2.33 2.33 0 0 1-.4-.9 2.165 2.165 0 0 1-.176-.993 2.356 2.356 0 0 1 .4.925 2.255 2.255 0 0 1 .176.968z",
    transform: "translate(-354.449 -145.973)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1670",
    d: "M578.116 218.806a4.151 4.151 0 0 1-.041-2.816 9.393 9.393 0 0 1 0 1.408 9.262 9.262 0 0 1 .041 1.408z",
    transform: "translate(-356.056 -144.766)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1671",
    d: "M555.013 197.347c-.032.054-2.356-1.047-5.194-2.464s-5.117-2.617-5.09-2.676 2.355 1.047 5.194 2.464 5.117 2.617 5.09 2.676z",
    transform: "translate(-337.881 -131.714)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1672",
    d: "M572.367 130.43c.05-2.283.063-4.684.063-4.684s-2.929-.564-3.438-4.418c-.487-3.673.875-12.3.875-12.3a10.292 10.292 0 0 1 11.651 3.317l-.726 18.532a3.981 3.981 0 0 1-4.3 3.687 4.206 4.206 0 0 1-4.125-4.134z",
    transform: "translate(-351.138 -85.712)",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1673",
    d: "M570.56 124.55a.5.5 0 0 0 .451.51.474.474 0 0 0 .519-.451.492.492 0 0 0-.451-.505.451.451 0 0 0-.519.447z",
    transform: "translate(-352.056 -94.34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1674",
    d: "M570.15 123.071c.059.063.451-.2.97-.185s.9.289.966.226-.027-.144-.194-.275a1.354 1.354 0 0 0-.776-.257 1.268 1.268 0 0 0-.772.226c-.167.12-.226.233-.194.265z",
    transform: "translate(-351.826 -93.505)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1675",
    d: "M582.469 125.29a.492.492 0 0 0 .451.51.451.451 0 0 0 .519-.451.487.487 0 0 0-.451-.505.451.451 0 0 0-.519.447z",
    transform: "translate(-358.591 -94.746)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1676",
    d: "M582.382 123.811c.059.068.451-.2.97-.185s.9.289.97.226-.032-.144-.2-.271a1.3 1.3 0 0 0-.772-.262 1.313 1.313 0 0 0-.776.226c-.16.122-.219.235-.192.266z",
    transform: "translate(-358.54 -93.912)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1677",
    d: "M576.29 127.644a3.41 3.41 0 0 0-.857-.176c-.135 0-.262-.05-.28-.14a.659.659 0 0 1 .1-.4l.424-1.015a17.631 17.631 0 0 0 .97-2.671 17.872 17.872 0 0 0-1.182 2.586c-.14.356-.28.7-.411 1.024a.79.79 0 0 0-.081.528.338.338 0 0 0 .216.208.926.926 0 0 0 .23.036 3.442 3.442 0 0 0 .871.02z",
    transform: "translate(-354.469 -93.868)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1678",
    d: "M576.74 145.361a9.774 9.774 0 0 0 5.171-1.241s-1.313 2.6-5.144 2.148z",
    transform: "translate(-355.447 -105.327)",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1679",
    d: "M583.873 120.117c-.108.167-.514.095-.966 0s-.848-.171-.9-.365.42-.451 1.024-.329.95.549.842.694z",
    transform: "translate(-358.334 -91.756)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1680",
    d: "M572.086 118.793c-.041.194-.474.266-.97.289s-.934 0-.993-.2.361-.478.961-.505 1.043.231 1.002.416z",
    transform: "translate(-351.813 -91.199)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1681",
    d: "M577.527 135.78a.262.262 0 0 0-.293.135.3.3 0 1 0 .18-.149",
    transform: "translate(-355.697 -100.737)",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1682",
    d: "M577.444 135.79c0-.023-.086-.153-.316-.1a.406.406 0 0 0-.289.284.433.433 0 0 0 .668.478.379.379 0 0 0 .162-.375c-.045-.239-.221-.275-.23-.244s.063.113.05.253a.212.212 0 0 1-.108.167.23.23 0 0 1-.23 0 .239.239 0 0 1-.081-.221.221.221 0 0 1 .122-.167c.126-.079.239-.043.252-.075z",
    transform: "translate(-355.493 -100.692)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1683",
    d: "M580.718 113.234c-.451 1.056-1.57 1.873-1.417 3.014.1.736.573 1.421.483 2.161-.117.9-1.078 1.57-1.218 2.5-.167 1.133.939 2.013 1.376 3.068.645 1.543-.176 3.276-.2 4.964a5.3 5.3 0 0 0 4.693 5.153 2.819 2.819 0 0 0 2.707-1.11 10.693 10.693 0 0 0 .614-2.468c.4-1.209 1.548-2.094 1.8-3.339.451-2.256-2.3-4.151-2.121-6.462a16.116 16.116 0 0 1 .943-2.8 4.115 4.115 0 0 0-.8-3.651c-.681-.808-1.665-1.354-2.256-2.22a9.208 9.208 0 0 1-.9-3.434 8.655 8.655 0 0 0-13.745-5.067 2.815 2.815 0 0 0 2.4 3.475c3.055.5 4.467-.077 4.81 1.146a3.231 3.231 0 0 0 .9 2.793c1.25 1.343 2.437 1.049 1.931 2.277z",
    transform: "translate(-352.089 -82.071)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1684",
    d: "M597.6 143.956a1.077 1.077 0 0 1-.28-.027 4.407 4.407 0 0 1-.776-.212 5.51 5.51 0 0 1-2.365-1.746 6.254 6.254 0 0 1-1-1.8 7.153 7.153 0 0 1-.411-2.315 9.563 9.563 0 0 1 .325-2.577 11.03 11.03 0 0 1 .451-1.3 13.338 13.338 0 0 0 .492-1.3 2.41 2.41 0 0 0 0-1.327 7.363 7.363 0 0 0-.51-1.236 8.122 8.122 0 0 1-.526-1.226 2.639 2.639 0 0 1-.095-1.3 9.184 9.184 0 0 1 1-2.125 4.02 4.02 0 0 0 .406-1.922 4.535 4.535 0 0 0-1.006-2.662 7.917 7.917 0 0 0-.763-.745 3.086 3.086 0 0 1 .835.686 4.511 4.511 0 0 1 1.1 2.707 4.17 4.17 0 0 1-.4 2.013 9.314 9.314 0 0 0-.966 2.08 3.85 3.85 0 0 0 .614 2.378 7.029 7.029 0 0 1 .532 1.277 2.658 2.658 0 0 1 0 1.444 14.13 14.13 0 0 1-.519 1.34 10.611 10.611 0 0 0-.451 1.277 9.3 9.3 0 0 0-.329 2.513 6.525 6.525 0 0 0 1.327 4.007 5.541 5.541 0 0 0 2.256 1.764c.674.267 1.059.307 1.059.334z",
    transform: "translate(-364.118 -92.167)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1685",
    d: "M586.419 112.741a3.188 3.188 0 0 1-.672.1 7 7 0 0 1-1.859-.05 3.542 3.542 0 0 1-2.346-1.421 7.657 7.657 0 0 1-.614-1.516 2.518 2.518 0 0 0-1.029-1.268 7.271 7.271 0 0 0-3.159-.826 5.51 5.51 0 0 1-2.631-.821 2.6 2.6 0 0 1-1.079-1.5 1.512 1.512 0 0 1-.032-.51c0-.117.027-.176.036-.176a3.189 3.189 0 0 0 .086.663 2.581 2.581 0 0 0 1.083 1.39 5.456 5.456 0 0 0 2.559.74 7.36 7.36 0 0 1 3.267.844 2.743 2.743 0 0 1 1.119 1.385 7.555 7.555 0 0 0 .582 1.48 3.407 3.407 0 0 0 2.193 1.354 7.79 7.79 0 0 0 1.8.122 4.564 4.564 0 0 1 .696.01z",
    transform: "translate(-353.39 -83.722)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1686",
    d: "M586.291 108.388a1.5 1.5 0 0 1-.528.077 3.217 3.217 0 0 1-2.256-.9 4.143 4.143 0 0 1-.7-.934 3.888 3.888 0 0 0-1.643-1.882 5.415 5.415 0 0 0-2.527-.221 7.751 7.751 0 0 1-2.157 0 2.707 2.707 0 0 1-1.354-.6 1.5 1.5 0 0 1-.262-.3q-.081-.117-.068-.122a3.013 3.013 0 0 0 .388.347 2.842 2.842 0 0 0 1.3.505 8.185 8.185 0 0 0 2.112-.036 5.415 5.415 0 0 1 2.64.226 2.594 2.594 0 0 1 1.078.9 11.6 11.6 0 0 1 .654 1.092 4.3 4.3 0 0 0 .654.9 3.16 3.16 0 0 0 .772.573 3.348 3.348 0 0 0 1.354.375 3.482 3.482 0 0 1 .543 0z",
    transform: "translate(-354.38 -83.041)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1687",
    d: "M602.856 144.529c-.023 0 .122-.3.289-.857a7.763 7.763 0 0 0 .3-2.419 7.364 7.364 0 0 0-.961-3.443c-.329-.591-.83-1.119-1.241-1.769a3.16 3.16 0 0 1-.451-1.088 2.431 2.431 0 0 1 .1-1.218 14.448 14.448 0 0 0 .8-2.152 3.118 3.118 0 0 0-.587-1.954 9.6 9.6 0 0 1-.483-.9 3.3 3.3 0 0 1-.257-.943 8.171 8.171 0 0 1 .054-1.719 4.565 4.565 0 0 0-.217-2.4 2.184 2.184 0 0 0-.533-.7.094.094 0 0 1 .054.027.55.55 0 0 1 .144.1 1.611 1.611 0 0 1 .42.537 4.458 4.458 0 0 1 .293 2.45 8.665 8.665 0 0 0-.023 1.683 4.332 4.332 0 0 0 .731 1.751 5.991 5.991 0 0 1 .492.961 2.255 2.255 0 0 1 .135 1.137 13.289 13.289 0 0 1-.808 2.193 2.256 2.256 0 0 0-.095 1.106 3 3 0 0 0 .424 1.006c.384.627.9 1.164 1.232 1.782a7.446 7.446 0 0 1 .939 3.551 7.3 7.3 0 0 1-.379 2.45 4.683 4.683 0 0 1-.262.623.827.827 0 0 1-.113.208z",
    transform: "translate(-368.03 -93.715)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1688",
    d: "M562.082 282.409s-3.041-28.807-3.217-39.452 4.788-21.15 4.788-21.15l19.438-.807s3.845 10.8 3.912 15.342c.135 8.817-2.342 17.522-2.058 24.516l.65 21.569",
    transform: "translate(-345.635 -147.515)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1689",
    d: "M589.351 278.6a3.1 3.1 0 0 1-.32.244l-.176.122-.19.185a3.126 3.126 0 0 0-.451.483 10.817 10.817 0 0 0-1.521 3.854 12.946 12.946 0 0 1-.984 2.744 4.8 4.8 0 0 1-.451.681c-.081.108-.158.226-.253.329l-.3.3a4.833 4.833 0 0 1-1.462.939c-1.087.478-2.319.7-3.438 1.268a5.415 5.415 0 0 0-2.5 2.843c-.551 1.223-.9 2.5-1.354 3.7a6.68 6.68 0 0 1-2.031 3.077 5.578 5.578 0 0 1-3.159 1c-1.047.063-2.017.032-2.888.162a4.562 4.562 0 0 0-2.175.821 3.051 3.051 0 0 0-1.011 1.426 2.166 2.166 0 0 0-.077 1.106c.054.253.122.375.108.379a1.138 1.138 0 0 1-.153-.37 2.073 2.073 0 0 1 .036-1.142 3.068 3.068 0 0 1 1.015-1.5 4.626 4.626 0 0 1 2.256-.9c.9-.144 1.864-.126 2.9-.194a5.415 5.415 0 0 0 3.064-.975 6.552 6.552 0 0 0 1.945-2.987c.451-1.187.781-2.473 1.354-3.718a5.64 5.64 0 0 1 2.608-2.956c1.164-.578 2.4-.8 3.456-1.259a4.733 4.733 0 0 0 1.408-.9l.284-.284c.09-.1.167-.212.248-.316a4.352 4.352 0 0 0 .42-.654 12.939 12.939 0 0 0 1-2.707 10.478 10.478 0 0 1 1.606-3.872 2.947 2.947 0 0 1 .451-.478c.072-.063.135-.126.2-.176l.185-.117a3.12 3.12 0 0 1 .35-.158z",
    transform: "translate(-348.736 -179.124)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1690",
    d: "M587.24 249.06a2.1 2.1 0 0 1 .027.384 4.732 4.732 0 0 1-.135 1.106 7.107 7.107 0 0 1-2.2 3.393 13.056 13.056 0 0 1-2.256 1.665c-.871.514-1.832 1.006-2.82 1.566a14.566 14.566 0 0 0-2.879 2.026 11.115 11.115 0 0 0-2.184 3.064 28.028 28.028 0 0 1-1.893 3.336 7.969 7.969 0 0 1-1.236 1.354 7.462 7.462 0 0 1-1.494.988 18 18 0 0 1-3.019 1.16 27.083 27.083 0 0 0-2.653.9 10.154 10.154 0 0 0-2.021 1.083 6.256 6.256 0 0 0-1.268 1.169 5.8 5.8 0 0 0-.763 1.263 2.386 2.386 0 0 1 .126-.365 4.508 4.508 0 0 1 .564-.957 6.076 6.076 0 0 1 1.264-1.218 10.3 10.3 0 0 1 2.035-1.128 27.084 27.084 0 0 1 2.658-.925 18.669 18.669 0 0 0 2.978-1.164 7.692 7.692 0 0 0 1.421-.957 8.01 8.01 0 0 0 1.191-1.327 29.043 29.043 0 0 0 1.873-3.312 11.2 11.2 0 0 1 2.256-3.123 14.541 14.541 0 0 1 2.933-2.049c.993-.555 1.954-1.038 2.825-1.548a13.033 13.033 0 0 0 2.256-1.615 7.157 7.157 0 0 0 2.22-3.3 6.891 6.891 0 0 0 .194-1.469z",
    transform: "translate(-346.508 -162.913)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1691",
    d: "M558.877 244.261a.342.342 0 0 1-.041-.09 2.378 2.378 0 0 1-.086-.266 2.157 2.157 0 0 1 .045-1.083 4.47 4.47 0 0 1 2.856-2.635c.8-.275 1.71-.451 2.658-.686a5 5 0 0 0 3.678-2.739 14.53 14.53 0 0 0 .672-1.62 17.646 17.646 0 0 1 1.43-3.461 5.513 5.513 0 0 1 2.942-2.288 26.707 26.707 0 0 1 3.38-.857 11.2 11.2 0 0 0 2.938-1 6.181 6.181 0 0 0 1.985-1.8 6.714 6.714 0 0 0 1.263-3.655 10.378 10.378 0 0 0-.095-1.444 4.7 4.7 0 0 1 .185 1.444 6.646 6.646 0 0 1-1.218 3.75 6.244 6.244 0 0 1-2.026 1.864 11.248 11.248 0 0 1-2.983 1.042 26.892 26.892 0 0 0-3.348.862 5.3 5.3 0 0 0-2.825 2.2 17.69 17.69 0 0 0-1.412 3.411 14.059 14.059 0 0 1-.69 1.647 5.961 5.961 0 0 1-1.011 1.4 5.866 5.866 0 0 1-2.82 1.421c-.957.244-1.859.4-2.649.659a4.372 4.372 0 0 0-2.825 2.5 2.289 2.289 0 0 0-.086 1.047 2.248 2.248 0 0 1 .081.384z",
    transform: "translate(-345.549 -147.312)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1692",
    d: "M588.622 327a1.711 1.711 0 0 1 .032.284 2.993 2.993 0 0 1-.086.812 4.607 4.607 0 0 1-1.706 2.437 7.52 7.52 0 0 1-1.8 1.065c-.69.293-1.453.528-2.256.776a18.639 18.639 0 0 0-2.441.9 6.97 6.97 0 0 0-2.17 1.62c-.659.686-1.227 1.439-1.859 2.107a8.472 8.472 0 0 1-2.08 1.624 9.166 9.166 0 0 1-4.291 1.119 8.547 8.547 0 0 1-2.951-.492 5.639 5.639 0 0 1-.749-.32 1.193 1.193 0 0 1-.248-.14 1.917 1.917 0 0 1 .266.095 7.983 7.983 0 0 0 .758.28 9.023 9.023 0 0 0 2.924.411 9.12 9.12 0 0 0 4.188-1.142 8.428 8.428 0 0 0 2.017-1.593c.618-.659 1.182-1.408 1.855-2.112a7.247 7.247 0 0 1 2.292-1.67 18.683 18.683 0 0 1 2.477-.9 23.587 23.587 0 0 0 2.256-.749 7.566 7.566 0 0 0 1.76-1.015 4.6 4.6 0 0 0 1.719-2.328 5.715 5.715 0 0 0 .093-1.069z",
    transform: "translate(-349.559 -205.684)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1693",
    d: "m587.624 166.939-3.763.09a6.087 6.087 0 0 1-.848 2.134 64.319 64.319 0 0 1-6.187-15.708c.09-.293.194-.618.325-.979a4.171 4.171 0 0 0-.05-1.652c-.108-.654-.289-1.534-.343-1.94-.167-1.245-.37-1.439-.8-1.3-.587.194.244 3.488-.239 3.56-.262.036-.578-1.092-.668-2.017s-.514-3.777-.817-3.966c-.451-.28-.844.162-.726 1.083s.257 3.718-.23 3.759-.9-4.688-.9-4.688.077-1.029-.492-1.006c-1.02.045-.221 5.027-.135 5.5.063.325-.451.388-.514.032s-.3-4.725-1.354-4.688c-.8 0 .618 4.1.167 5.049s-.758-3.213-1.521-3.159c-.284.023-.5.077.027 2.428a53.308 53.308 0 0 0 1.8 5.51c1.209 6.52 6.516 27.381 14.832 23.564 4.657-2.139 6.543-11.606 6.543-11.606z",
    transform: "translate(-350.777 -105.43)",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1694",
    d: "M575.528 150.1a.221.221 0 0 0 .108 0 .239.239 0 0 0 .167-.262c0-.28-.054-.686-.117-1.214a16.942 16.942 0 0 1-.208-1.922c0-.379 0-.785.023-1.214a4.44 4.44 0 0 1 .068-.65c.036-.2.171-.451.329-.411h.027a.36.36 0 0 1 .334.307 1.767 1.767 0 0 1 .063.6 35.219 35.219 0 0 0 .483 3.768c.036.167.072.338.126.51a1.953 1.953 0 0 0 .09.257 1.452 1.452 0 0 0 .077.135.248.248 0 0 0 .19.117.334.334 0 0 0 .284-.239 1.287 1.287 0 0 0 .086-.275 4.542 4.542 0 0 0 .072-.551 16.433 16.433 0 0 0-.032-2.256 5.1 5.1 0 0 1-.045-1.133.632.632 0 0 1 .221-.42.239.239 0 0 1 .194-.023.367.367 0 0 1 .108.045.144.144 0 0 1 .05.068 5.763 5.763 0 0 1 .311 1.133 34.877 34.877 0 0 1 .383 2.463 9.181 9.181 0 0 0 .208 1.286 4.947 4.947 0 0 0 .2.636 1.2 1.2 0 0 0 .189.32.266.266 0 0 0 .266.1.28.28 0 0 0 .185-.2 2.258 2.258 0 0 0 .05-.7 6.485 6.485 0 0 0-.05-.668c-.032-.379-.068-.754-.081-1.124a4.4 4.4 0 0 1 0-.546.9.9 0 0 1 .059-.235.22.22 0 0 1 .041-.068h.059c.3-.122.4.293.478.627s.113.713.185 1.069c.117.708.271 1.417.347 2.094a2.494 2.494 0 0 1-.036.975c-.108.325-.217.645-.32.966v.059a51.979 51.979 0 0 0 2.017 6.525c.713 1.927 1.43 3.61 2.058 4.964s1.2 2.414 1.584 3.127l.451.808a1.519 1.519 0 0 0 .176.271 1.816 1.816 0 0 0-.14-.289l-.451-.826c-.37-.727-.9-1.8-1.516-3.159s-1.309-3.037-2-4.964a53.9 53.9 0 0 1-1.976-6.507v.063c.1-.316.208-.636.316-.957a2.583 2.583 0 0 0 .054-1.078c-.081-.708-.23-1.394-.347-2.107-.068-.352-.113-.713-.185-1.083a1.985 1.985 0 0 0-.095-.56.533.533 0 0 0-.248-.253.573.573 0 0 0-.356 0h-.072a.294.294 0 0 0-.1.059.4.4 0 0 0-.113.158 1.023 1.023 0 0 0-.077.307 4.267 4.267 0 0 0 0 .587c0 .379.054.758.086 1.137 0 .221.036.451.045.654a2.193 2.193 0 0 1-.032.609c0 .045-.036.036 0 .059l-.027-.027a.9.9 0 0 1-.135-.244 4.457 4.457 0 0 1-.194-.6 8.381 8.381 0 0 1-.2-1.25q-.072-.636-.176-1.259a26.828 26.828 0 0 0-.216-1.227 5.5 5.5 0 0 0-.343-1.2.384.384 0 0 0-.14-.158.781.781 0 0 0-.167-.072.5.5 0 0 0-.384.054.844.844 0 0 0-.334.587 2.19 2.19 0 0 0 0 .618c0 .194.045.384.059.573a16.689 16.689 0 0 1 .041 2.22 3.833 3.833 0 0 1-.068.523 1.006 1.006 0 0 1-.068.235.276.276 0 0 1-.05.081c0 .041-.032 0-.027.054v-.059a.886.886 0 0 1-.054-.095c-.032-.072-.059-.153-.086-.23-.05-.162-.086-.329-.122-.492a35.862 35.862 0 0 1-.51-3.736 1.964 1.964 0 0 0-.077-.672.631.631 0 0 0-.176-.3.451.451 0 0 0-.334-.126h.027a.393.393 0 0 0-.393.185 1 1 0 0 0-.135.352 4.55 4.55 0 0 0-.063.677v1.227a15.705 15.705 0 0 0 .248 1.931c.077.523.135.93.162 1.2a.212.212 0 0 1-.131.235.681.681 0 0 0-.178.026z",
    transform: "translate(-354.723 -105.404)",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1695",
    d: "M499.423 208.227a9.661 9.661 0 0 0-2.613.3c-2.333.614-6.354 3.05-6.521 6.06h2.924s-1.638 3.484-1.16 3.159a37.565 37.565 0 0 0 3.732-3.362z",
    transform: "translate(-308.007 -140.505)",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1696",
    d: "M597.686 78.83c-.068 0-.329-2.41-.591-5.415S596.67 68 596.733 68s.329 2.41.591 5.415.425 5.415.362 5.415z",
    transform: "translate(-366.411 -63.555)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1697",
    d: "M616.31 68.41c.05.036-1.922 2.9-4.409 6.4s-4.549 6.317-4.6 6.263 1.922-2.9 4.409-6.4 4.546-6.3 4.6-6.263z",
    transform: "translate(-372.216 -63.78)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1698",
    d: "M626.5 97.182c0 .063-2.292.591-5.144 1.178s-5.18 1.011-5.194.948 2.288-.591 5.144-1.178 5.16-1.011 5.194-.948z",
    transform: "translate(-377.079 -79.566)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1699",
    d: "m277.05 227.818-15.974 82.036L259 320.593l106.493-.514c4.783-.023 9.025-4.269 10.555-10.577l18.889-77.446c1.169-4.788-1.394-9.769-5.022-9.765L282.1 222.4c-2.343 0-4.446 2.218-5.05 5.418z",
    transform: "translate(-181.084 -148.223)",
    style: {
      fill: "#014a62"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5356",
    style: {
      opacity: 0.5
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1700",
    d: "m95.966 79.595-15.974 82.036-2.076 10.739 106.493-.514c4.783-.023 9.025-4.269 10.555-10.577l18.889-77.446c1.169-4.788-1.394-9.769-5.022-9.765l-107.815.109c-2.343 0-4.446 2.218-5.05 5.418z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1701",
    d: "M307.89 285.583 296.609 194.7a7.14 7.14 0 0 0-6.931-6.489l-24.728.077a6.769 6.769 0 0 0-4.887 2.166l-11.733 12.484-68.769.37c-4.2.023-7.432 4-6.877 8.47l10.473 84a7.149 7.149 0 0 0 6.922 6.489l119.872-.239c13.348.275 14.625-3.664 14.625-3.664-15.324 3.387-16.686-12.758-16.686-12.781z",
    transform: "translate(-133.683 -129.521)",
    style: {
      fill: "#014a62"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1704",
    d: "M505.821 88.8a.835.835 0 0 1-.51-.736l-.18-4.188a.839.839 0 0 1 1.033-.857 2.626 2.626 0 0 0 2.04-.4 2.351 2.351 0 0 0 1.051-1.543 2.4 2.4 0 0 0-.505-1.8 2.707 2.707 0 0 0-1.778-1.069 3.159 3.159 0 0 0-3.2 2.256.844.844 0 0 1-1.624-.451 4.855 4.855 0 0 1 5.022-3.506 4.359 4.359 0 0 1 2.929 1.728 4.12 4.12 0 0 1 .826 3.1 4.061 4.061 0 0 1-1.8 2.671 4.386 4.386 0 0 1-2.283.745l.14 3.231a.844.844 0 0 1-1.173.808z",
    transform: "translate(-314.5 -68.214)",
    style: {
      fill: "#014a62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1705",
    d: "M511.383 106.8a.686.686 0 1 1-.234-.474.69.69 0 0 1 .234.474z",
    transform: "translate(-318.825 -84.493)",
    style: {
      fill: "#014a62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1706",
    d: "M478.113 72.832a2.121 2.121 0 0 0 .041-.271c0-.2.05-.451.086-.808a9.768 9.768 0 0 1 .221-1.3c.059-.253.09-.532.18-.817s.18-.591.28-.9a15.566 15.566 0 0 1 2.256-4.3 15.116 15.116 0 0 1 4.742-4.124 14.892 14.892 0 0 1 3.344-1.381 15.14 15.14 0 0 1 3.858-.505 14.964 14.964 0 0 1 2.053.108c.347.036.69.126 1.038.185a7.724 7.724 0 0 1 1.038.253 14.441 14.441 0 0 1 4.012 1.819 15.089 15.089 0 0 1 5.965 7.491 14.772 14.772 0 0 1 .9 5.149 14.511 14.511 0 0 1-.943 5.3l-.2.514-.027.068.027.068c1.133 2.6 2.256 5.162 3.317 7.64l.19-.217-6.77-2.604-.081-.032-.068.063a14.879 14.879 0 0 1-18.564 1.791 15.419 15.419 0 0 1-3.8-3.542 14.984 14.984 0 0 1-2.888-6.922l-.14-1.173c-.04-.343 0-.623-.023-.862a4.032 4.032 0 0 1 0-.528.09.09 0 1 0-.027 0v1.4c0 .343.077.736.122 1.182a16.142 16.142 0 0 0 .772 3.186 16.521 16.521 0 0 0 2.067 3.836 15.557 15.557 0 0 0 3.831 3.61 15.026 15.026 0 0 0 18.83-1.742l-.149.032 6.769 2.608.338.131-.149-.347c-1.074-2.477-2.184-5.031-3.312-7.639v.131l.208-.528a14.757 14.757 0 0 0 .966-5.415 15.1 15.1 0 0 0-.9-5.261 15.342 15.342 0 0 0-6.1-7.63A14.575 14.575 0 0 0 497.3 58.7a7.174 7.174 0 0 0-1.056-.248c-.352-.063-.7-.153-1.051-.185a15.518 15.518 0 0 0-2.08-.117 15.144 15.144 0 0 0-3.917.532 15.428 15.428 0 0 0-3.389 1.417 15.149 15.149 0 0 0-4.77 4.219 15.433 15.433 0 0 0-2.225 4.368c-.095.325-.185.636-.266.9a7.929 7.929 0 0 0-.171.826 8.58 8.58 0 0 0-.19 1.309c-.027.347-.045.614-.059.812a1.144 1.144 0 0 0-.013.299z",
    transform: "translate(-301.29 -58.148)",
    style: {
      fill: "#263238"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataList);
export default __webpack_public_path__ + "static/media/no-data-list.0d51b38f2c3d1a2e3ecfaae43b49b41b.svg";
export { ForwardRef as ReactComponent };